import React from 'react';
import "./abilities.css";
import "./responsive.css";
import Ability from './Ability';
import cveData from '../../CVE/data';

const Abilities = () => {
  const cveCount = `${cveData.length}x`;

  return (
    <div className='abilities'>
      <div className="ability-container wrap">
        <Ability number={cveCount} description="CVE" />
        <Ability number="60+" description="CTF Challenges Created" />
        <Ability number="3x" description="CTF Champion" />
      </div>
    </div>
  )
}

export default Abilities
